<template>
  <div class="helpme">
    <div class="helpmeBg">
      <CommProgress
        v-if="helpnum!==-1"
        @showFriend="commOpenModal"
        :helplist="helplist"
        :helpnum="helpnum"
        :helpwish="helperInfo.wish_str"
        :maxUser="max_help_user"
      ></CommProgress>
      <div class="helpBtnView">
        <div
          v-if="btnStatus>=0"
          @click="helpMe"
          v-bind:class="{helpBtn:btnStatus == 0 || btnStatus == 2, helpBtn3:btnStatus==1 , helpBtn2:btnStatus==3 }"
        >
          <p v-if="btnStatus == 0" class="helpBtnText">我要祝福</p>
          <p
            v-if="btnStatus == 1"
            class="helpBtnText"
          >{{iswish == 1 ? '你已祝福，返回活动首页' : '你已祝福，自己也去许个愿'}}</p>
          <p v-if="btnStatus == 2" class="helpBtnText">去抽奖</p>
          <p v-if="btnStatus == 3" class="helpBtnText2">活动已结束</p>
        </div>
      </div>
    </div>
    <div class="helpReward">
      <Reward v-bind:mypoint="'sharepg#adclick'"></Reward>
    </div>
    <div
      @click="_downloadAPP(2,'sharepg#pop_getsuccess_appdownload')"
      class="helpPrize btn-clipboard"
      v-show="downapp==true"
      id="btnH5D1"
      data-clipboard-target="#hello2"
    >
      <input type="hidden" id="hello2" value style="display:none;" />
      <p class="closeModal" @click.stop="closeModal($event)">×</p>
    </div>
    <!-- 祝福成功 -->
    <div class="help-alert-wrap flex-column" v-if="modalStatu=='success' && myaward ">
      <div class="help-alert flex-column">
        <div class="help-alert-title">{{isBind==0 ? '祝福成功': '领取成功'}}</div>
        <div class="help-alert-desc">{{isBind==0 ? '旅行路上有你真好': '已放入您的账户，可前往【我的奖品】查看'}}</div>
        <div class="help-alert-gift flex-row">
          <div class="help-alert-gift-left">
            <img class="help-alert-gift-default" src="../../static/images/gift_default.png" alt />
          </div>
          <div class="help-alert-gift-right flex-data">
            <p class="help-alert-gift-text">{{myaward.award_desc}}</p>
            <div class="help-alert-gift-time">有效期至{{activityInfo.end_time_format}}</div>
          </div>
        </div>
        <div
          v-if="isBind==0"
          @click="commOpenModal('undefined')"
          class="common-bg help-alert-btn"
        >领取</div>
        <div
          v-else
          class="common-bg help-alert-btn btn-clipboard"
          id="btnH5"
          data-id="btnH5"
          @click="_downloadAPP(1,'sharepg#pop_getsuccess_appdownload')"
          data-clipboard-target="#hello"
        >去APP使用</div>
        <input type="hidden" id="hello" value style="display:none;" />
      </div>
      <img
        @click="commHideModal('success')"
        class="alert-close"
        src="../../static/images/alert_close.png"
        alt
      />
    </div>
    <!-- 祝福失败 -->
    <div class="help-alert-wrap flex-column" v-if="modalStatu=='fail'">
      <div class="help-alert fail flex-column">
        <div class="help-alert-title">{{helpTitle}}</div>
        <div class="help-alert-name">{{helpContent}}</div>
        <div v-if="helpContent!=='祝福已达上限'" class="help-alert-desc02">下载无忧行领取更多奖励</div>
        <div
          v-if="helpContent!=='祝福已达上限'"
          class="common-bg help-alert-btn"
          @click="downApp2"
        >下载无忧行APP</div>
      </div>
      <img
        @click="commHideModal('fail')"
        class="alert-close"
        src="../../static/images/alert_close.png"
        alt
      />
    </div>
    <!-- 好友列表 -->
    <FriendModal :modalStatu="modalStatu" :helplist="helplist" @commHideModal="commHideModal"></FriendModal>
    <!-- <div class="help-alert-wrap flex-column" v-if="modalStatu=='friend'">
      <div class="help-alert flex-column helpFriend">
        <div class="help-alert-title">好友祝福</div>
        <div class="userInfoViwe">
          <div class="userInfo" v-for="(i,key) in helplist" v-bind:key="key">
            <img class="userAvatar" :src="i.avatar" alt />
            <p class="userNikeName">{{i.nickname}}</p>
          </div>
        </div>
      </div>
      <img @click="commHideModal('friend')" class="alert-close" src="../../static/images/alert_close.png" alt />
    </div>-->
    <!-- 登录弹出 -->
    <BindPhone
      v-show="modalStatu=='bindphone'"
      @closePhone="commHideModal('bindphone')"
      v-on:changeBind="changeBind"
    ></BindPhone>
    <!-- 分享弹出层 -->
    <van-overlay :show="helpOverlay">
      <div class="helpShareView">
        <div class="helpShare">
          <img class="helpShareBtn" src="../../static/images/help_share_btn.png" alt />
          <p class="helpShareBtnText">点击可进行分享</p>
          <div @click="controlOverlay(false)" class="helpClose">
            <p class="helpCloseText">关闭</p>
          </div>
        </div>
      </div>
    </van-overlay>
    <!-- 祝福成功点击关闭  -->
    <div class="help-alert-wrap flex-column" v-if="modalStatu=='vows'">
      <div class="help-alert fail flex-column">
        <div class="help-alert-title">许愿</div>
        <div class="help-alert-name vowsText">许下2020年的第一个旅游愿望</div>
        <div class="vowBtnView">
          <div class="vowBtn">
            <p @click="toNewVow" class="vowBtnText">去许愿</p>
          </div>
          <div @click="returnVow" class="vowBtn">
            <p class="vowBtnText">星愿池</p>
          </div>
        </div>
      </div>
      <img
        @click="commHideModal('fail')"
        class="alert-close"
        src="../../static/images/alert_close.png"
        alt
      />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Progress, Overlay } from "vant";
import Reward from "../components/Reward.vue";
import CommProgress from "../components/Progress.vue";
import BindPhone from "../components/Phone.vue";
import FriendModal from "../components/FriendModal.vue";
Vue.use(Progress)
  .use(Reward)
  .use(CommProgress)
  .use(BindPhone)
  .use(Overlay);
export default {
  name: "HelpMe",
  components: { Reward, CommProgress, BindPhone, FriendModal },
  data() {
    return {
      downapp: true,
      modalStatu: "hide", //success fail frien bindphone vows  弹出层状态 默认隐藏
      helplist: [],
      helpnum: -1, //不能改！！！   防止异步请求的数据回来，组件不渲染
      helpTitle: "你已祝福",
      helpContent: "不可重复祝福",
      btnStatus: -1, //0 立即祝福  1你已祝福  2分享  3.活动已结束
      isme: 0,
      ishelp: 0,
      helpOverlay: false,
      isBind: 0,
      helperInfo: null,
      myaward: null,
      iswish: 0,
      routerStatu: "none" //路由状态，必须登录才能跳转的路由，通过此状态记录登录成功的跳转
    };
  },

  methods: {
    //关闭下载无忧行app 底部广告
    closeModal() {
      this.downapp = false;
    },
    changeBind() {
      switch (this.routerStatu) {
        case "none":
          window.location.reload();
          break;
        case "newvow":
          this.$router.push({
            path: "/newvow"
          });
          break;
      }
      //window.location.reload();
    },
    // 下载app,对应埋点
    downApp2() {
      var t = this;
      var mypoint = "sharepg#pop_limited_appdownload";
      if (t.helpTitle == "领取失败") {
        mypoint = "sharepg#pop_getfair_appdownload";
      } else if (t.helpTitle == "你已祝福") {
        mypoint = "sharepg#pop_assisted_appdownload";
      }
      t._downloadAPP(0, mypoint);
    },
    //获取被祝福人信息
    async getNeedHelpUserInfo() {
      var t = this;
      let obj = {};
      var params = {
        uid: t._getAPPParams().share_userid,
        // ty:1-本人，2-非本人，为2时必须传uid
        ty: 2
      };
      await t
        ._get("user", "User.getNeedHelpUserInfo", params)
        .then(res => {
          if (res.status == 0) {
            obj = res.data;
            t.helperInfo = res.data.need_help_user;
            t.helplist = res.data.helper_list;
            t.isme = res.data.isme;
            t.ishelp = res.data.ishelp;
            t.max_help_user = res.data.max_help_user;
            // 必须获取到信息才能判断 sweety
            t.enableBtn();
            t.helpnum = parseInt(res.data.need_help_user.help_num);
          } else {
            // typeof callback == "function" && callback(error);
            t.$toast(res.msg);
          }
        })
        .catch(error => {
          // typeof callback == "function" && callback(error);
          console.log(`error:${error}`);
          t.$toast("请求错误");
        });
      return obj;
    },
    //祝福提交
    helpMe() {
      let t = this;
      switch (this.btnStatus) {
        case 0:
          t._deepmain(t.pageId, "sharepg#assist", 2);
          helpsubmit();
          break;
        case 1:
          if (t.iswish == 1) {
            t.$router.push({
              path: "/vowdraw",
              query: {}
            });
          } else {
            t.$router.push({
              path: "/",
              query: {}
            });
          }
          break;
        case 2:
          t.$router.push({
            path: "/vowdraw",
            query: {}
          });
          // helpshare();
          break;
        case 3:
          break;
      }
      function helpsubmit() {
        var params = {
          help_uid: t._getAPPParams().share_userid
        };
        t._get("user", "User.helpMember", params)
          .then(res => {
            if (res.status == 0) {
              t.myaward = res.data;
              t.commOpenModal("success");
            } else {
              if (res.status == 30003) {
                // 已经为他祝福过了，不能重复祝福
                t.helpTitle = "你已祝福";
                t.helpContent = "不可重复祝福";
                t.commOpenModal("fail");
              } else if (res.status == 50009) {
                //祝福已达上限
                t.helpTitle = "祝福失败";
                t.helpContent = "祝福已达上限";
                t.commOpenModal("fail");
              } else {
                //领取失败
                t.helpTitle = "领取失败";
                t.helpContent = "来晚一步，奖品被抢走了";
                t.commOpenModal("fail");
              }
            }
          })
          .catch(error => {
            console.log(`error:${error}`);
            t.$toast("请求错误");
          });
      }
      function helpshare() {
        t.controlOverlay(true);
      }
    },
    //打开弹窗
    commOpenModal(status) {
      let stu = status;
      if (stu == "undefined") {
        if (this.isBind == 0) {
          stu = "bindphone";
          this._deepmain(this.pageId, "sharepg#pop_getaward", 2);
        } else {
          this._deepmain(this.pageId, "sharepg#pop_getsuccess_appdownload", 2);
        }
      }
      this.modalStatu = stu;
    },
    //关闭弹窗
    async commHideModal(status) {
      let stu = "hide";
      if (status == "bindphone") {
        if (this.isBind == 0) {
          //关闭登录，若还未绑定。则返回领取弹窗
          stu = "success";
        }
      }
      //领取成功  关闭当前,打开许愿弹窗
      if (this.modalStatu == "success") {
        if (this.iswish == 1) {
          //已许愿直接关闭弹出
          await this.getNeedHelpUserInfo();
          stu = "hide"; //重置所有隐藏弹窗
        } else {
          stu = "vows"; //未许愿 弹出许愿
        }
      }
      //许愿弹窗关闭，刷新当前祝福状态。
      if (status == "fail" && this.modalStatu == "vows") {
        await this.getNeedHelpUserInfo();
      }
      this.modalStatu = stu;
    },
    //判断加载的按钮
    enableBtn() {
      let _this = this;
      _this.btnStatus = 0;
      if (_this.ishelp == 1) {
        _this.btnStatus = 1;
      }
      if (_this.isme == 1) {
        // 分享
        _this.btnStatus = 2;
        if (_this.iswish == 1) {
          _this.$router.push({
            path: "/vowdraw",
            query: {}
          });
        } else {
          _this.$router.push({
            path: "/",
            query: {}
          });
        }
      }
      if (_this.activityInfo.isover == 1) {
        _this.btnStatus = 3;
      }
    },
    //判断是否绑定手机号  返回对象
    async getBaseUser() {
      var _this = this;
      var params = {
        rec_uid: _this._getAPPParams().share_userid,
        activity_id: _this._getAPPParams().activity_id
      };
      await _this._signup("user", "User.getUserInfo", params).then(res => {
        if (res.status == 0) {
          _this.isBind = res.data.user.isbindtel;
          _this.iswish = res.data.user.iswish;
        }
      });
    },
    //控制分享按钮
    controlOverlay(status) {
      this.helpOverlay = status;
    },
    //返回许愿首页
    returnVow() {
      var t = this;
      //埋点
      t._deepmain(t.pageId, "sharepg#pop_wishpool", 2);
      t.$router.push({
        path: "/",
        query: {
          isreturn: true
        }
      });
    },
    //许愿页
    toNewVow() {
      var t = this;
      //埋点
      t._deepmain(t.pageId, "sharepg#pop_makewish", 2);
      if (t.isBind == 0) {
        //未绑定手机号，弹出登录
        t.modalStatu = "bindphone";
        t.routerStatu = "newvow"; //记录去许愿路由
        return;
      }
      t.$router.push({
        path: "/newvow"
      });
    },
    //点击底部广告
    downApp() {
      let t = this;
      t._downloadAPP(0, "sharepg#appdownload");
    }
  },
  mounted() {
    let _this = this;
    _this._deepmain(_this.pageId, "sharepg#access", 1);
    if (_this._getAPPParams().share_userid > 0) {
      _this.getNeedHelpUserInfo();
      _this.getBaseUser();
    } else {
      _this.$router.push({
        path: "/",
        query: {}
      });
    }
  }
};
</script>
<style scoped lang="scss" src="../../static/scss/helpme.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>

